import ApiClient from './ApiClient';

export default class AnnouncementApi extends ApiClient {
  hitContacts (dealType, realtyType, realtyId, page) {
    return this.post(`${dealType}/${realtyType}/${realtyId}/hitContacts?page=${page}`);
  }

  /**
   * Загрузить одно объявление
   * @param dealType
   * @param realtyType
   * @param id
   * @param filter
   * @returns {*}
   */
  fetchAnnouncementItem (dealType, realtyType, id, filter) {
    return this.get(`${this.prefix}${dealType}/${realtyType}/${id}`, filter);
  }

  fetchAnnouncement (dealType, realtyType, filter) {
    return this.get(`${this.prefix}${dealType}/${realtyType}`, filter);
  }

  fetchCountAnnouncement (dealType, realtyType, filter) {
    return this.get(`${this.prefix}${dealType}/${realtyType}/total`, filter);
  }

  fetchPremiumAnnouncement (dealType, realtyType, params) {
    return this.get(`${this.prefix}${dealType}/${realtyType}/widget/premium`, params);
  }

  /**
   * Загрузить объявления по списку id
   * @param dealType
   * @param realtyType
   * @param data
   * @param source
   * @returns {Promise.<TResult>|*}
   */
  fetchAnnouncementList (dealType, realtyType, data, source) {
    const {idList, isDealCompleted} = data;
    return this.axios().post(
      `${this.prefix}map/${dealType}/${realtyType}`,
      {
        id: idList.join(','),
        isDealCompleted: isDealCompleted ? 1 : null
      },
      {
        cancelToken: source.token
      })
      .then(res => res.data);
  }

  /**
   * Подписаться на изменения цены
   * Объект с параметрами { dealType, realtyType, realtyId, email }
   * @param params
   * @returns {*}
   */
  priceSubscription (params) {
    const {dealType, realtyType, realtyId, email} = params;

    return this.post(`/${dealType}/${realtyType}/${realtyId}/priceTracking`, { email });
  }
}



// WEBPACK FOOTER //
// ./src/api/Announcement.js